// An inline svg sits on the baseline of antd's 26px icon box, which left ~3.5px of descender space
// under it, so a one-line toast had more room below the title than above. Block with 0.1rem margins
// centres the 24px glyph on the 26px title line.
.icon {
  display: block;
  margin-block: 0.1rem;
}

.success {
  color: var(--success);
}

.info {
  color: var(--primary);
}

.error {
  color: var(--danger);
}

.warning {
  color: var(--warning);
}
